import baseAPI from '@/http'

const router = 'api/salaindicadoresunidade'

export const salaIndicadorUnidade = {
  create: (ur) => baseAPI.post(router, ur),
  update: (ur) => baseAPI.put(router, ur),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`)
}
